/* ============================================================================
   BlueBox — Registro: el nombre se completa a partir del número de identificación

   Consulta el registro público de contribuyentes del Ministerio de Hacienda:

       GET https://api.hacienda.go.cr/fe/ae?identificacion=<numero>

   Verificado el 19 de agosto de 2026:
   - Devuelve `nombre` tanto de persona física (tipoIdentificacion "01") como de
     razón social (tipoIdentificacion "02").
   - Responde con `access-control-allow-origin: *`, así que el navegador puede
     llamarlo directamente. Por eso ESTE ARCHIVO NO NECESITA NADA DEL BACKEND:
     no hay controlador nuevo, no se recompila el ensamblado.
   - Contesta también por personas que no son contribuyentes: el régimen viene
     como "No tiene" y el nombre igual llega.

   Reglas de comportamiento, en orden de importancia:

   1. NUNCA bloquea el registro. Si el servicio no contesta, tarda o no conoce
      el número, el campo queda como estaba: escribible y sin error. Un cliente
      no puede perder el registro porque un servicio del Estado esté caído.
   2. No pisa lo que la persona escribió. Si ya tocó el campo de nombre a mano,
      el resultado de la consulta se descarta.
   3. Solo aplica a cédula física y jurídica. Con pasaporte no se consulta:
      Hacienda no lo resuelve y pedirlo sería filtrar el número sin provecho.

   Un aviso para quien mantenga esto: si algún día el portal se sirve con una
   política de seguridad de contenido (CSP), hay que permitir
   `connect-src https://api.hacienda.go.cr` o esta consulta se cae en silencio.
   ========================================================================== */

(function () {
    'use strict';

    var TIPO_FISICA = '0';
    var TIPO_JURIDICA = '1';
    var ENDPOINT = 'https://api.hacienda.go.cr/fe/ae?identificacion=';
    var ESPERA_MS = 450;      // lo que se aguarda a que termine de escribir
    var LIMITE_MS = 6000;     // más que esto y se abandona la consulta
    var MIN_DIGITOS = 9;      // la cédula física tiene 9; la jurídica, 10

    var selTipo = document.getElementById('TypeIdentification');
    var campoId = document.getElementById('Identification');
    var campoNombre = document.getElementById('Name');

    if (!selTipo || !campoId || !campoNombre) { return; }

    var nombreEditadoAMano = false;
    var ultimoConsultado = '';
    var temporizador = null;
    var enCurso = null;

    function soloDigitos(valor) {
        return (valor || '').replace(/\D/g, '');
    }

    function aplicable() {
        return selTipo.value === TIPO_FISICA || selTipo.value === TIPO_JURIDICA;
    }

    /* Hacienda devuelve todo en mayúsculas ("LUIS BENJAMIN PADILLA ROMERO").
       En una pantalla de perfil eso grita, así que se pasa a capitalización de
       nombre. Las partículas van en minúscula, como se escriben en español, y
       se respetan los guiones de apellidos compuestos. */
    var PARTICULAS = ['de', 'del', 'la', 'las', 'los', 'y', 'e', 'da', 'do', 'dos', 'van', 'von'];

    function capitalizar(nombre) {
        var palabras = (nombre || '').toLowerCase().split(/\s+/).filter(Boolean);
        return palabras.map(function (palabra, indice) {
            if (indice > 0 && PARTICULAS.indexOf(palabra) !== -1) { return palabra; }
            return palabra.split('-').map(function (parte) {
                return parte ? parte.charAt(0).toUpperCase() + parte.slice(1) : parte;
            }).join('-');
        }).join(' ');
    }

    function escribirNombre(nombre) {
        if (nombreEditadoAMano) { return; }
        campoNombre.value = nombre;
        // El validador de jQuery escucha estos eventos: sin ellos el campo
        // seguiría marcado como vacío hasta que la persona lo toque.
        campoNombre.dispatchEvent(new Event('input', { bubbles: true }));
        campoNombre.dispatchEvent(new Event('change', { bubbles: true }));
    }

    function consultar(numero) {
        if (enCurso) { enCurso.abort(); }

        var control = new AbortController();
        enCurso = control;
        var corte = setTimeout(function () { control.abort(); }, LIMITE_MS);

        fetch(ENDPOINT + encodeURIComponent(numero), {
            method: 'GET',
            headers: { 'Accept': 'application/json' },
            signal: control.signal,
            // El servicio es público y no usa sesión: sin credenciales.
            credentials: 'omit',
            referrerPolicy: 'no-referrer'
        })
            .then(function (respuesta) {
                if (!respuesta.ok) { throw new Error('sin registro'); }
                return respuesta.json();
            })
            .then(function (datos) {
                var nombre = datos && datos.nombre ? String(datos.nombre).trim() : '';
                if (!nombre) { throw new Error('sin nombre'); }

                escribirNombre(capitalizar(nombre));
            })
            .catch(function () {
                /* Sin registro, sin red, o se agotó el tiempo. No se le dice
                   nada a la persona: el campo queda vacío y escribible, que es
                   exactamente lo que pasaba antes de que existiera esta
                   consulta. Un cartel acá solo agregaría ruido a la pantalla. */
            })
            .then(function () {
                clearTimeout(corte);
                if (enCurso === control) { enCurso = null; }
            });
    }

    function evaluar() {
        clearTimeout(temporizador);

        if (!aplicable()) { return; }

        var numero = soloDigitos(campoId.value);
        if (numero.length < MIN_DIGITOS) {
            ultimoConsultado = '';
            return;
        }
        if (numero === ultimoConsultado) { return; }

        ultimoConsultado = numero;
        temporizador = setTimeout(function () { consultar(numero); }, ESPERA_MS);
    }

    campoId.addEventListener('input', evaluar);
    campoId.addEventListener('blur', evaluar);
    selTipo.addEventListener('change', function () {
        ultimoConsultado = '';
        evaluar();
    });

    /* Solo cuenta como edición a mano lo que se teclea, no lo que escribe este
       guion: `escribirNombre` despacha eventos sintéticos y `isTrusted` los
       distingue de los reales. */
    campoNombre.addEventListener('input', function (evento) {
        if (evento.isTrusted) { nombreEditadoAMano = true; }
    });
})();
